import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CommonTable from "../../common-components/common-tables/CommonTable";
import {
  LocationIcon,
  ReloadIcon,
} from "../../../images/icons/icons";
import { getTrialsIcon } from "../../pt-trials/member-report/MemberReportMocks";
import { fetchHygieneCommandCenterGymComplianceData } from "../../../redux/hygiene-reducers/hygieneSlice";

const GymComplianceTable = ({ userInfoData, prevFilters, setModValues }) => {
  const dispatch = useDispatch();
  const {
    hygieneCommandCenterGymCompliance,
    hygieneCommandCenterGymComplianceLoading,
    hygieneCommandCenterGymComplianceError,
  } = useSelector((state) => state.hygiene);

  const [pageLimit, setPageLimit] = useState(10);
  const [isPage, setIsPage] = useState(0);
  const iniFilters = {
    ...prevFilters,
    limit: pageLimit || 10,
    page: isPage + 1,
  };
  const [filters, setFilters] = useState(iniFilters);

  const iniTbDatas = {
    allDatas: [],
    pagination: [],
    statsData: {},
  };
  const [TbData, setTbData] = useState(iniTbDatas);

  const getStatusBadge = (status) => {
    const statusConfig = {
      excellent: { className: "tb-data tb-badge tb-badge-success" },
      average: { className: "tb-data tb-badge tb-badge-success-2" },
      good: { className: "tb-data tb-badge tb-existing" },
      fair: { className: "tb-data tb-badge tb-badge-stuck" },
      poor: { className: "tb-data tb-badge not-assigned" },
      error: { className: "tb-data tb-badge not-assigned" },
    };
    return statusConfig[status] || { className: "tb-data tb-badge" };
  };

  function getCommandCenterGymCompliance() {
    dispatch(
      fetchHygieneCommandCenterGymComplianceData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getCommandCenterGymCompliance();
  }, [filters]);

  useEffect(() => {
    if (
      !hygieneCommandCenterGymComplianceLoading &&
      !hygieneCommandCenterGymComplianceError &&
      hygieneCommandCenterGymCompliance?.status &&
      hygieneCommandCenterGymCompliance?.data
    ) {
      const { date, average_compliance } =
        hygieneCommandCenterGymCompliance.data || {};

      setTbData((prevs) => ({
        ...prevs,
        allDatas: hygieneCommandCenterGymCompliance.data?.gyms || [],
        pagination: hygieneCommandCenterGymCompliance?.pagination || [],
        statsData: { date, average_compliance },
      }));
    } else {
      setTbData(iniTbDatas);
    }
  }, [
    hygieneCommandCenterGymComplianceLoading,
    hygieneCommandCenterGymComplianceError,
    hygieneCommandCenterGymCompliance,
  ]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      ...prevFilters,
      limit: pageLimit || 10,
      page: isPage + 1,
    }));
  }, [pageLimit, isPage, prevFilters]);

  const tbColumns = [
    {
      dataField: "gym_id",
      text: "Gym Name",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.gym_name || "NA"}</span>;
      },
    },
    {
      dataField: "total_tasks",
      text: "Total",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.total_tasks || 0}</span>;
      },
    },
    {
      dataField: "completed",
      text: "Completed",
      formatter: (_, row) => {
        return (
          <span className="tb-data hcc-table-completed">
            {row?.completed || 0}
          </span>
        );
      },
    },
    {
      dataField: "pending",
      text: "Pending",
      formatter: (_, row) => {
        return (
          <span className="tb-data hcc-table-pending">{row?.pending || 0}</span>
        );
      },
    },
    {
      dataField: "missed",
      text: "Missed",
      formatter: (_, row) => {
        return (
          <span className="tb-data hcc-table-missed">{row?.missed || 0}</span>
        );
      },
    },
    {
      dataField: "compliance_percent",
      text: "Compliance %",
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-badge tb-existing">
            {Math.round(row?.compliance_percent ?? 0)}%
          </span>
        );
      },
    },
    {
      dataField: "status_label",
      text: "Status",
      formatter: (_, row) => {
        const statusInfo = getStatusBadge(row?.status_label?.toLowerCase());

        return (
          <span className={statusInfo.className}>
            {row?.status_label || "-"}
          </span>
        );
      },
    },
    // {
    //   dataField: "action",
    //   text: "Action",
    //   formatter: (_, row) => (
    //     <div className="pp-employee-payroll-actions">
    //       <button
    //         key="view-detail"
    //         type="button"
    //         className="pp-employee-payroll-action-button pp-outlined-border"
    //         onClick={() => alert(`View details for ${row.gymName}`)}
    //       >
    //         <EyeIcon />
    //         View Details
    //       </button>
    //     </div>
    //   ),
    // },
  ];

  return (
    <>
      <div className="hcc-compliance-section mt30 mb30">
        <div className="hcc-section-header">
          <div className="hcc-section-title-container">
            <h2 className="hcc-section-title">Gym wise Compliance</h2>
            <button
              type="button"
              className="hcc-reload-button"
              onClick={() => getCommandCenterGymCompliance()}
              title="Reload"
            >
              <ReloadIcon />
            </button>
          </div>

          <div className="hcc-stats-container">
            <div className="hcc-stat-badge hcc-stat-badge-gyms">
              <LocationIcon color="#4F46E5" />
              <span className="hcc-stat-label hcc-stat-label-gyms">
                Total Gyms:{" "}
                <span className="hcc-stat-value">{TbData.allDatas.length}</span>
              </span>
            </div>

            <div className="hcc-stat-badge hcc-stat-badge-compliance">
              {getTrialsIcon("hcc-stat-icon")}
              <span className="hcc-stat-label hcc-stat-label-compliance">
                Avg Compliance:{" "}
                <span className="hcc-stat-value">
                  {TbData.statsData?.average_compliance || 0}%
                </span>
              </span>
            </div>

            {/* <button
              className="btn btn-success hcc-export-btn"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "exportModal",
                }))
              }
            >
              <DownloadIcon size={16} color="#FFF" /> Export to Excel
            </button> */}
          </div>
        </div>

        <div className="common-table-container mt15">
          <CommonTable
            tableData={TbData.allDatas}
            tableColumns={tbColumns}
            tablePagination={TbData.pagination}
            isPage={isPage}
            setIsPage={setIsPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            isLoading={hygieneCommandCenterGymComplianceLoading}
          />
        </div>
      </div>
    </>
  );
};

export default GymComplianceTable;
